<template>
  <div v-for="(gift, index) in sortedGifts" :key="index">
    <LazyMarketingCardGift
      :gift="gift"
      :type="type"
      :enable-gift-redemption="enableGiftRedemption"
    />
  </div>
</template>

<script setup lang="ts">
import type { GiftStoryblok } from '~/types/component-types-sb';

const props = defineProps<{
  gifts: GiftStoryblok[];
  type: string;
  enableGiftRedemption: boolean;
}>();

const sortedGifts = computed(() => {
  return [...props.gifts].sort((a, b) => {
    // First, sort by price (highest to lowest)
    if (b.content.price !== a.content.price) {
      return Number(b.content.price) - Number(a.content.price);
    }
    // If prices are equal, sort alphabetically by name
    return (a.name || '').localeCompare(b.name || '');
  });
});
</script>
